import { render, staticRenderFns } from "./AdminProducersSubMenusLinks.vue?vue&type=template&id=5b3f9bfd"
import script from "./AdminProducersSubMenusLinks.vue?vue&type=script&lang=js"
export * from "./AdminProducersSubMenusLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b3f9bfd')) {
      api.createRecord('5b3f9bfd', component.options)
    } else {
      api.reload('5b3f9bfd', component.options)
    }
    module.hot.accept("./AdminProducersSubMenusLinks.vue?vue&type=template&id=5b3f9bfd", function () {
      api.rerender('5b3f9bfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/sub-menus/producers/AdminProducersSubMenusLinks.vue"
export default component.exports